/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "jquery",
  "underscore",
  "utils/keys",
  "i18n/i18n",
  "utils/dom"
], function ($, _, keys, i18n, dom) {

var DELAY = 500;
var tabpanel = function () {};

tabpanel.prototype.switchTabs = function($tab, delay) {
  var that = this,
      call = function () {
        var $otherTabs = that.$tabs.not($tab);

        $otherTabs.attr('tabindex', '-1');
        $tab.attr('tabindex', '0');

        if (that.accordian == false) {
          $otherTabs.each(function () {
            var $otherPanel = $('#' + this.getAttribute('aria-controls'));
            $otherPanel.attr('aria-hidden', 'true');
            $otherPanel.slideUp(100);
          });

          var $panel = that.$panel.find('#' + $tab.attr('aria-controls'));
          $panel.removeAttr('aria-hidden');
          $panel.slideDown(100);

          $otherTabs.attr('aria-selected', 'false');
          $otherTabs.attr('aria-expanded', 'false');
          $otherTabs.trigger("tabdeactivate");
          $tab.attr('aria-selected', 'true');
          $tab.attr('aria-expanded', 'true');
          $tab.trigger("tabactivate");
        }

        if ($tab.attr("data-action-object")) {
          $tab.click();
        }
    };

  window.clearTimeout(this._activateTimeout);
  $tab.focus();

  if (delay) {
    this._activateTimeout = window.setTimeout(function () {
      call();
    }, delay);
  } else {
    call();
  }
}

tabpanel.prototype.togglePanel = function($tab) {
  var $panel = this.$panel.find('#' + $tab.attr('aria-controls'));

  if ($tab.attr("aria-expanded") !== "false") {
    $panel.attr('aria-hidden', 'true');
    $panel.slideUp(100);

    // update the aria-expanded attribute
    $tab.attr('aria-expanded', 'false');
    $tab.attr("title", i18n("Open"));
    $tab.attr("aria-selected", "false");
    $tab.trigger("accordiondeactivate");
  }
  else {
    $panel.removeAttr('aria-hidden');
    $panel.slideDown(100);

    // update the aria-expanded attribute
    $tab.attr('aria-expanded', 'true');
    $tab.attr("title", i18n("Close"));
    $tab.attr("aria-selected", "true");
    $tab.trigger("accordionactivate");
  }
}

tabpanel.prototype.updateFields = function () {
  this.$tabs = this.$panel.find(this.tabSelector); // Array of panel tabs.
  this.$panels = this.$panel.find(this.panelSelector); // Array of panel.
}

tabpanel.prototype.handleTabKeyDown = function($tab, e) {
  if (/input|select|option/i.test(e.target.tagName)) return;

  if (e.altKey) {
    // do nothing
    return true;
  }

  switch (e.keyCode) {
    case keys.enter:
    case keys.space: {
      // Only process if this is an accordian widget
      if (this.accordian == true) {
        // display or collapse the panel
        this.togglePanel($tab);

        e.stopPropagation();
        return false;
      }

      return true;
    }
    case keys.left:
    case keys.up: {
      this.updateFields();

      var thisObj = this;
      var $prevTab; // holds jQuery object of tab from previous pass
      var $newTab; // the new tab to switch to

      if (e.ctrlKey) {
        // Ctrl+arrow moves focus from panel content to the open
        // tab/accordian header.
      }
      else {
        var curNdx = this.$tabs.index($tab);

        if (curNdx == 0) {
          // tab is the first one:
          // set newTab to last tab
          $newTab = this.$tabs.last();
        }
        else {
          // set newTab to previous
          $newTab = this.$tabs.eq(curNdx - 1);
        }

        // switch to the new tab
        this.switchTabs($newTab, DELAY);
      }

      e.stopPropagation();
      return false;
    }
    case keys.right:
    case keys.down: {
      this.updateFields();

      var thisObj = this;
      var foundTab = false; // set to true when current tab found in array
      var $newTab; // the new tab to switch to

      var curNdx = this.$tabs.index($tab);

      if (curNdx == this.$tabs.length-1) {
        // tab is the last one:
        // set newTab to first tab
        $newTab = this.$tabs.first();
      }
      else {
        // set newTab to next tab
        $newTab = this.$tabs.eq(curNdx + 1);
      }

      // switch to the new tab
      this.switchTabs($newTab, DELAY);

      e.stopPropagation();
      return false;
    }
    case keys.home: {
      this.updateFields();

      // switch to the first tab
      this.switchTabs(this.$tabs.first(), DELAY);

      e.stopPropagation();
      return false;
    }
    case keys.end: {
      this.updateFields();

      // switch to the last tab
      this.switchTabs(this.$tabs.last(), DELAY);

      e.stopPropagation();
      return false;
    }
  }
}

tabpanel.prototype.handleTabKeyPress = function($tab, e) {
  if (/input|select|option/i.test(e.target.tagName)) return;

  if (e.altKey) {
    // do nothing
    return true;
  }

  switch (e.keyCode) {
    case keys.enter:
    case keys.space:
    case keys.left:
    case keys.up:
    case keys.right:
    case keys.down:
    case keys.home:
    case keys.end: {
      e.stopPropagation();
      return false;
    }
    case keys.pageup:
    case keys.pagedown: {

      // The tab keypress handler must consume pageup and pagedown
      // keypresses to prevent Firefox from switching tabs
      // on ctrl+pageup and ctrl+pagedown

      if (!e.ctrlKey) {
        return true;
      }

      e.stopPropagation();
      return false;
    }
  }

  return true;
}

tabpanel.prototype.handleTabClick = function($tab, e) {
  this.updateFields();
  var $otherTabs = this.$tabs.not($tab);

  const clickedTabIsSelected = $tab.attr("aria-selected") === "true";

  $tab.attr('tabindex', '0');
  $tab.focus();
  $otherTabs.attr('tabindex', '-1');

  if (this.accordian == false) {
    if (clickedTabIsSelected) {
      this.togglePanel($tab)
    } else {
      this.switchTabs($tab);
    }
  } else {
    this.togglePanel($tab);
  }

  e.stopPropagation();
  return false;
}

tabpanel.prototype.handlePanelKeyDown = function($panel, e) {
  if (/input|select|option/i.test(e.target.tagName)) return;

  if (e.altKey) {
    // do nothing
    return true;
  }

  switch (e.keyCode) {
    case keys.tab: {
      this.updateFields();
      var $focusable = $panel.find(dom.focusableElements());
      var curNdx = $focusable.index($(e.target));
      var panelNdx = this.$panels.index($panel);
      var numPanels = this.$panels.length

      if (e.shiftKey) {
        // if this is the first focusable item in the panel
        // find the preceding expanded panel (if any) that has
        // focusable items and set focus to the last one in that
        // panel. If there is no preceding panel or no focusable items
        // do not process.
        if (curNdx == 0 && panelNdx > 0) {

          // Iterate through previous panels until we find one that
          // is expanded and has focusable elements
          //
          for (var ndx = panelNdx - 1; ndx >= 0; ndx--) {

            var $prevPanel = this.$panels.eq(ndx);
                  var $prevTab = $('#' + $prevPanel.attr('aria-labelledby'));

            // get the focusable items in the panel
            $focusable.length = 0;
            $focusable = $prevPanel.find(dom.focusableElements());

            if ($focusable.length > 0) {
              // there are focusable items in the panel.
              // Set focus to the last item.
              $focusable.last().focus();

              if (this.accordian == false) {
                this.$tabs.attr('aria-selected', 'false');
                $prevTab.attr('aria-selected', 'true');
              }

              e.stopPropagation();
              return false;
            }
          }
        }
      }
      else if (panelNdx < numPanels) {

        // if this is the last focusable item in the panel
        // find the nearest following expanded panel (if any) that has
        // focusable items and set focus to the first one in that
        // panel. If there is no preceding panel or no focusable items
        // do not process.
        if (curNdx == $focusable.length - 1) {

          // Iterate through following panels until we find one that
          // is expanded and has focusable elements
          //
          for (var ndx = panelNdx + 1; ndx < numPanels; ndx++) {

            var $nextPanel = this.$panels.eq(ndx);
                  var $nextTab = $('#' + $nextPanel.attr('aria-labelledby'));

            // get the focusable items in the panel
            $focusable.length = 0;
            $focusable = $nextPanel.find(dom.focusableElements());

            if ($focusable.length > 0) {
              // there are focusable items in the panel.
              // Set focus to the first item.
              $focusable.first().focus();

              if (this.accordian == false) {
                this.$tabs.attr('aria-selected', 'false');
                $nextTab.attr('aria-selected', 'true');
              }

              e.stopPropagation;
              return false;
            }
          }
        }
      }

      break;
    }
    case keys.left:
    case keys.up: {

      if (!e.ctrlKey) {
        // do not process
        return true;
      }

      // get the jQuery object of the tab
      var $tab = $('#' + $panel.attr('aria-labelledby'));

      // Move focus to the tab
      $tab.focus();

      e.stopPropagation();
      return false;
    }
    case keys.pageup: {
      var $newTab;

      this.updateFields();

      if (!e.ctrlKey) {
        // do not process
        return true;
      }

      // get the jQuery object of the tab
      var $tab = this.$tabs.filter("[aria-expanded=true]");

      // get the index of the tab in the tab list
      var curNdx = this.$tabs.index($tab);

      if (curNdx == 0) {
        // this is the first tab, set focus on the last one
        $newTab = this.$tabs.last();
      }
      else {
        // set focus on the previous tab
        $newTab = this.$tabs.eq(curNdx - 1);
      }

      // switch to the new tab
      this.switchTabs($newTab, DELAY);

      e.stopPropagation();
      e.preventDefault();
      return false;
    }
    case keys.pagedown: {
      this.updateFields();

      var $newTab;

      if (!e.ctrlKey) {
        // do not process
        return false;
      }

      // get the jQuery object of the tab
      var $tab = $('#' + $panel.attr('aria-labelledby'));

      // get the index of the tab in the tab list
      var curNdx = this.$tabs.index($tab);

      if (curNdx == this.$tabs.length-1) {
        // this is the last tab, set focus on the first one
        $newTab = this.$tabs.first();
      }
      else {
        // set focus on the next tab
        $newTab = this.$tabs.eq(curNdx + 1);
      }

      // switch to the new tab
      this.switchTabs($newTab, DELAY);

      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }

  return true;

} // end handlePanelKeyDown()

//
// Function handlePanelKeyPress() is a member function to process keypress events for a panel
//
// @param ($panel obj) $panel is the jquery object of the panel being processed
//
// @param (e obj) e is the associated event object
//
// @return (boolean) Returns true if propagating; false if consuming event
//
tabpanel.prototype.handlePanelKeyPress = function($panel, e) {
  if (/input|select|option/i.test(e.target.tagName)) return;

  if (e.altKey) {
    // do nothing
    return true;
  }

  if (e.ctrlKey && (e.keyCode == keys.pageup || e.keyCode == keys.pagedown)) {
      e.stopPropagation();
      e.preventDefault();
      return false;
  }

  switch (e.keyCode) {
    case keys.esc: {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }

  return true;

}

tabpanel.prototype.handlePanelClick = function($panel, e) {
  this.updateFields();

  var $tab = $('#' + $panel.attr('aria-labelledby')),
      $otherTabs = this.$tabs.not($tab);


  $tab.attr('tabindex', '0');
  $otherTabs.attr('tabindex', '-1');

  if (this.accordian == false) {
    $tab.attr('aria-selected', 'true');
    $otherTabs.attr('aria-selected', 'false');
  }

  return true;

} // end handlePanelClick()

// focusable is a small jQuery extension to add a :focusable selector. It is used to
// get a list of all focusable elements in a panel. Credit to ajpiano on the jQuery forums.
//
$.extend($.expr.pseudos[':'], {
  focusable: function(element) {
    var nodeName = element.nodeName.toLowerCase();
    var tabIndex = $(element).attr('tabindex');

    // the element and all of its ancestors must be visible
    if (($(element)[(nodeName == 'area' ? 'parents' : 'closest')](':hidden').length) == true) {
      return false;
    }

    // If tabindex is defined, its value must be greater than 0
    if (!isNaN(tabIndex) && tabIndex < 0) {
      return false;
    }

    // if the element is a standard form control, it must not be disabled
    if (/input|select|textarea|button|object/.test(nodeName) == true) {
      return !element.disabled;
    }

    // if the element is a link, href must be defined
    if ((nodeName == 'a' ||  nodeName == 'area') == true) {

      return (element.href.length > 0);
    }

    // this is some other page element that is not normally focusable.
    return false;
  }
});

 return _.extend(tabpanel.prototype, {
  tabSelector: "[role=tab][aria-hidden!=true]",
  panelSelector: "[role=tabpanel][aria-hidden!=true]",

  update: function ($el, e) {
    var that = this;

    this.$panel = $el;
    this.$el = $el;

    e.preventDefault();
    e.stopPropagation();

    this.accordian = /true/i.test($el.attr("aria-multiselectable")); // true if this is an accordian control
    this.updateSelection();

    this.$panel.on("focus.mb-role-tablist", function(e) {
      that.updateSelection();
      e.preventDefault();
      e.stopPropagation();
    });

    this.$panel.on("keydown.mb-role-tablist", this.tabSelector, function(e) {
      return that.handleTabKeyDown($(this), e);
    });

    this.$panel.on("keypress.mb-role-tablist", this.tabSelector, function(e) {
      return that.handleTabKeyPress($(this), e);
    });

    this.$panel.on("keydown.mb-role-tablist", this.panelSelector, function(e) {
      return that.handlePanelKeyDown($(this), e);
    });

    this.$panel.on("keypress.mb-role-tablist", this.panelSelector, function(e) {
      return that.handlePanelKeyPress($(this), e);
    });

    this.$panel.on("click.mb-role-tablist", this.panelSelector, function(e) {
      return that.handlePanelClick($(this), e);
    });

    this.$panel.on("click.mb-role-tablist", this.tabSelector, function(e) {
      return that.handleTabClick($(this), e);
    });

  },
  getFocusedElement: function() {
    var activeEl = document.activeElement;
  
    if (activeEl && activeEl.shadowRoot && activeEl.shadowRoot.activeElement) {
      activeEl = activeEl.shadowRoot.activeElement;
    }
    return activeEl;
  },

  updateSelection: function () {
    var $toSelect;
    var activeEl = this.getFocusedElement();
    var activeElementInControl = (activeEl.hasAttribute("data-prevent-refocus") || /input/i.test(activeEl && activeEl.tagName)) && !!this.$el.find(activeEl).length;
    var changeSelection = !activeElementInControl;
    var $otherTabs;
    this.updateFields();
    this.$tabs.each(function () {
      var activeElementInTab = this === activeEl || !!$(this.parentNode).find(activeEl).length;
      if (!$toSelect && activeElementInTab) {
        $toSelect = $(this);
        changeSelection = false;
      }
    });

    if (!$toSelect) {
      this.$tabs.each(function () {
        if (!$toSelect && this.getAttribute("tabindex") === "0") {
          $toSelect = $(this);
        } else {
          this.setAttribute("tabindex", "-1");
        }
      });
    }

    if (!$toSelect) {
      $toSelect = this.$tabs.first();
    }
    
    $otherTabs = this.$tabs.not($toSelect);
    $toSelect.attr("tabindex", "0")
    $otherTabs.attr('tabindex', '0');

    if (changeSelection) {
      $toSelect.focus();
    }
  },

  destroy: function () {
    this.$panel && this.$panel.off(".mb-role-tablist");
  }
  });
});
